import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../elementals/icon';
import classnames from 'classnames/bind';
import styles from './index.scss';
const cx = classnames.bind(styles);
const Panel = ({ children, onClose, className, elmId, cls: extcls }) => (_jsxs("div", { className: cx('root', className), "data-elm-id": elmId, children: [children, _jsx(Icon, { name: 'times', size: 'big', iconStyle: 'regular', style: { color: 'inherit' }, "data-elm-id": `${elmId}_close_icon`, className: cx('close', extcls.close), onClick: onClose })] }));
Panel.propTypes = {
    cls: PropTypes.shape({
        close: PropTypes.string,
    }),
    className: PropTypes.string,
    elmId: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
};
Panel.defaultProps = {
    elmId: 'property_gallery_media_panel',
    cls: {
        close: '',
    },
};
const View = ({ children, className, elmId }) => (_jsx("div", { className: cx('view', className), "data-elm-id": elmId, children: children }));
View.propTypes = {
    elmId: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
};
View.defaultProps = {
    elmId: 'property_gallery_media_panel_view',
};
export default Panel;
export { Panel, View };
//# sourceMappingURL=index.js.map